import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

const dataToken = document.querySelector("#token");

Vue.use(VueAxios, axios);
// Vue.axios.defaults.baseURL = "https://sandbox-siga.grupo4rodas.com.br/api/v1/";
Vue.axios.defaults.baseURL = "/api/v1/";

if (dataToken) {
  Vue.axios.defaults.headers.common["Authorization"] = dataToken.dataset.token;
}

Vue.axios.defaults.headers.common["Cache-Control"] = "no-cache, no-store";
Vue.axios.defaults.headers.common["Pragma"] = "no-cache";

// Vue.use({
//   install(Vue) {
//     Vue.prototype.$http = axios.create({
//       baseURL: 'http://localhost:3001/api/v1/'
//     })
//   }
// })
